import DatasetTreeGardener from '../dataset-tree-gardener'
import SingleTreeSelector from 'scoreboard/components/single-tree-selector'
import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'
import Tooltip from 'scoreboard/components/tooltip'
import highlight from 'scoreboard/components/highlight'

var DatasetTreeItemSelector = SingleTreeSelector.extend({

	className: 'single-item-selector dataset-tree-item-selector datasets-tree single-tree-selector',

	Gardener: DatasetTreeGardener,

	title: () => i18n.get('datasets.trees.selectItem'),

	primaryButtonText: () => i18n.get('common.select'),

	render: function() {
		SingleTreeSelector.prototype.render.apply(this, arguments)
		// usually the gardener selects options.id and also uses options.id to
		// locate  the tree, but the dataset tree isn't quite as fancy as the trees
		// in the nav pane.  Note the select method already accounts for the
		// tree possibly not being loaded yet
		this.options.selectedId && this.gardener.select(this.options.selectedId)

		if (!_.isNil(this.options.invalidIds)) {
			this.gardener.tree.on('rebind', () => this.disableInvalidNodes())
			this.gardener.tree.on('select', (node) => this.toggleExistingRecordTooltip(node))
			this.$('.tree').on('scroll', () => this.removeExistingRecordTooltip)
		}

		// #48393 restrict tree selection when editing geographic fields
		if (!_.isNil(this.options.geographicLevel)) {
			this.gardener.tree.on('rebind', () => this.disableInvalidGeographicLevelNodes())
			this.gardener.tree.on('select', (node) => {
				this.toggleInvalidGeographicLevelTooltip(node)
				this.toggleSubmitButtonForInvalidGeographicSelection(node)
			})
			this.$('.tree').on('scroll', () => this.removeInvalidGeographicLevelTooltip())
		}
	},

	/**
	 * gives all the nodes that aren't valid selections the disabled appearance
	 */
	disableInvalidNodes: function() {
		// wait for the nodes to load so this will stick
		process.nextTick(() => {
			_.each(this.$('.node'), n => {
				const itemEl = this.$(n)
				const itemId = itemEl.data('id')
				itemEl.toggleClass('invalid-selection', this.isInvalidId(itemId))
			})
		})

		// disable the submit if appropriate
		const selected = this.gardener.tree.selected()
		this.$('.button-primary').attr('disabled', this.isInvalidId(selected.id))
	},

	/**
	 * given the currently selected node, toggle the visibility of
	 * the tooltip and enable/disable the primary button accordingly
	 */
	toggleExistingRecordTooltip: function(node) {
		this.removeExistingRecordTooltip()
		if (this.isInvalidId(node.id)) {
			this.existingRecordTooltip = new Tooltip({
				attachTo: this.$(`.node[data-id=${node.id}]`),
				content: i18n.get('forms.widgets.invalidRollupSelection',
					highlight(node.label)),
				placement: 'right',
				arrow: 'center',
				extraClass: 'has-error'
			}).render()
		}
	},

	isInvalidId: function(id) {
		return _.includes(this.options.invalidIds, id.toString())
	},

	removeExistingRecordTooltip: function() {
		this.existingRecordTooltip && this.existingRecordTooltip.remove()
	},

	/**
	 * If a geographic level has been provided, give nodes at an invalid level
	 * a disabled appearance
	 */
	disableInvalidGeographicLevelNodes: function() {
		if (_.isNil(this.options.geographicLevel)) return
		// wait for the nodes to load
		process.nextTick(() => {
			_.each(this.$('.node'), n => {
				const itemEl = this.$(n)
				const itemId = itemEl.data('id')
				let node = this.gardener.tree.get(itemId)
				let invalid = this.isInvalidGeographicLevel(node)
				itemEl.toggleClass('invalid-selection', invalid)
			})
		})
	},

	/**
	 * Returns true if the given node is not at the specified geographic level
	 * @param node
	 * @returns {boolean}
	 */
	isInvalidGeographicLevel: function(node) {
		if (_.isNil(this.options.geographicLevel)) return false
		let validLevel = this.options.geographicLevel
		let nodeLevel =  _.get(node, 'type')
		return nodeLevel != validLevel
	},

	/**
	 * Toggles the visibility of the invalid geographic tooltip for the selected
	 * node
	 */
	toggleInvalidGeographicLevelTooltip: function(node) {
		this.removeExistingRecordTooltip()
		if (this.isInvalidGeographicLevel(node)) {
			this.invalidGeographicLevelTooltip = new Tooltip({
				attachTo: this.$(`.node[data-id=${node.id}]`),
				content: i18n.get('forms.widgets.invalidMapLevelSelection',
					highlight(node.label), highlight(this.options.fieldLabel)),
				placement: 'right',
				arrow: 'center',
				extraClass: 'has-error'
			}).render()
		}
	},

	removeInvalidGeographicLevelTooltip: function() {
		this.invalidGeographicLevelTooltip?.remove()
	},

	toggleSubmitButtonForInvalidGeographicSelection: function (node) {
		let invalid = this.isInvalidGeographicLevel(node)
		this.$('.button-primary').attr('disabled', invalid)
	},

	remove: function() {
		SingleTreeSelector.prototype.remove.apply(this, arguments)
		_.invokeMap([this.existingRecordTooltip,
			this.invalidGeographicLevelTooltip], 'remove')
	}

})

export default DatasetTreeItemSelector

DatasetTreeItemSelector.__filename__ = 'datasets/records/dataset-tree-item-selector.js'
